import React, { useEffect, useState } from "react";

const RoundedImageUpload = ({ value = null, onChange = () => {}, onRemove = () => {} }) => {
  const [image, setImage] = useState(null);

  // Sync with API value
  useEffect(() => {
    if (!value) {
      setImage(null);
      return;
    }

    // If API gives a string → convert to object
    if (typeof value === "string") {
      setImage({ url: value, file: null });
    } else {
      setImage(value);
    }
  }, [value]);

  // Select local file
  const handleSelectImage = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    const imgObj = { url, file };

    setImage(imgObj);
    onChange(imgObj);
  };

  const handleRemove = () => {
    // Cleanup object URL if created
    if (image?.file) URL.revokeObjectURL(image.url);

    setImage(null);
    onRemove(null);
  };

  return (
    <div className="relative w-36 h-36">
      <label
        className="
          w-full h-full rounded-full overflow-hidden 
          bg-white/40 backdrop-blur-xl
          shadow-inner shadow-gray-200 border border-white/70
          flex items-center justify-center cursor-pointer
          transition-all hover:shadow-xl hover:border-primary/50
          group
        "
      >
        {image?.url ? (
          <img
            src={image.url}
            alt="logo"
            className="w-full h-full object-cover rounded-full"
          />
        ) : (
          <div className="text-center text-gray-500 pointer-events-none">
            <i className="fa-light fa-cloud-arrow-up text-3xl mb-1" />
            <div className="text-xs uppercase tracking-wide">Upload</div>
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleSelectImage}
        />

        {image && (
          <div
            className="
              absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100
              flex items-center justify-center text-white text-sm
              transition-all duration-300 backdrop-blur-[2px]
            "
          >
            Change
          </div>
        )}
      </label>

      {image && (
        <button
          type="button"
          onClick={handleRemove}
          className="
            absolute -top-2.5 -right-2.5 bg-white text-red-500 border
            w-7 h-7 rounded-full shadow flex items-center justify-center
            hover:bg-red-50 transition
          "
        >
          <i className="fa-regular fa-xmark text-base" />
        </button>
      )}
    </div>
  );
};

export default RoundedImageUpload;
